import { isLocalhost } from "@/constant";
import { useTenantStore } from "@/stores/tenantStore";

export const getAuthBaseUrl = async (): Promise<string> => {
  const backendApiUrl = await useTenantStore.getState().getBackendApiUrl();
  return `${backendApiUrl}/api/authentication`;
};

export const getTenantDomain = (): string => {
  return isLocalhost
    ? new URL(String(process.env.AUTH_API_BASE_URL)).hostname
    : window.location.host;
};
